import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import type { IInitialEWalletValues } from '../edit-bank-info/interfaces';
import { useParams } from 'react-router-dom';
import { queryClient } from '@core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

export const createEWallet = async ({
  ...data
}: Partial<IInitialEWalletValues>) => {
  const formData = new FormData();

  if (data.logo) {
    const modifiedAvatar =
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (data.logo as any) instanceof File
        ? data.logo
        : new Blob([data.logo], {
            type: 'image/png',
          });
    formData.append('logo', modifiedAvatar);
  }
  formData.append('provider_name', data.provider_name ?? '');
  formData.append('recipient_name', data.recipient_name ?? '');
  formData.append('recipient_number', data.recipient_number?.toString() ?? '');
  return await request({
    url: 'ewallets/',
    method: 'POST',
    body: formData,
  });
};

export const useCreateEWallet = () => {
  const { organizationSlug } = useParams();
  return useMutation({
    mutationFn: createEWallet,
    onError: (error: string) => {
      toast.error(error);
    },
    onSuccess: () => {
      toast.success('Bank info has created successfully.');
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getBankInfo, organizationSlug],
      });
    },
  });
};
